export default [
    {
        //旅行助手
        path:'/travel',
        component: resolve => require(['@/pages/travel/travel.vue'], resolve),
        meta: { title: "长龙航空" },
    },
    {
        path:'/travel/info',
        component: resolve => require(['@/pages/travel/info.vue'], resolve),
        meta:{ title: "长龙航空" },
    },
]


// WEBPACK FOOTER //
// ./src/router/modules/travel.js